import Vue from "vue"
import mountShortcastEpisodePage from "./mount"
import getLocale from "../../utils/locale"

const id = "shortcast_episode_player"

export default () => {
  const el = document.querySelector(`#${id}`)

  if (!el) return

  const episodeData = JSON.parse(el.dataset.episode || "{}")
  const shortcastData = JSON.parse(el.dataset.shortcast || "{}")

  const vm = mountShortcastEpisodePage(Vue, {
    locale: getLocale(),
    episodeData,
    shortcastData
  })

  vm.$mount(el)
}
